<h2 mat-dialog-title>Unir con un paciente existente</h2>

<mat-dialog-content>
  <p>
    Los estudios de este paciente pasan al paciente que elijas, y la ficha creada
    desde el estudio de imágenes se elimina.
  </p>

  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Buscar por nombre o DNI</mat-label>
    <input matInput [(ngModel)]="busqueda" autocomplete="off" />
  </mat-form-field>

  <mat-selection-list [multiple]="false">
    <mat-list-option
      *ngFor="let p of filtrados"
      [value]="p"
      (click)="seleccionado = p"
      [selected]="seleccionado?.id === p.id"
    >
      {{ p.nombreApellido }} - {{ p.numeroDocumento }}
    </mat-list-option>
  </mat-selection-list>

  <p *ngIf="busqueda.length >= 2 && filtrados.length === 0">Sin resultados.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [mat-dialog-close]="null">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="!seleccionado || cargando"
    (click)="confirmar()"
  >
    Unir
  </button>
</mat-dialog-actions>
